module.exports = __webpack_public_path__ + "img/lock.abe1284f.svg";